import Vue from 'vue';
import Vuex from 'vuex';
import DataService from "./services/DataService";
import router from "./router";
import helpers from "../resources/assets/js/helpers";
import axios from "axios";
import { EventBus } from "./EventBus";

Vue.use(Vuex);

// Helper function to check if a package is eligible for discount
//renter could be package as wll
function isPackageEligibleForDiscount(renter, coupon) {
    // If no coupon is applied, no discount
    if (!coupon) {
        return false;
    }

    // If coupon has no package restrictions, apply to all packages
    if (!coupon.applicable_packages || coupon.applicable_packages.length === 0) {
        return true;
    }

    // Check if this renter's package is in the applicable packages list
    return coupon.applicable_packages.includes(renter.package_resort_id);
}

function isAddonEligibleForDiscount(addon, coupon) {
    if (!coupon || !coupon.addon_discount) {
        return false;
    }

    if (!coupon.applicable_addons || coupon.applicable_addons.length === 0) {
        return true;
    }

    return coupon.applicable_addons.includes(addon.id);
}

function getDiscountedAddonUnitPrice(addon, coupon, getters) {
    let unitPrice = getters.getAddonDailyPrice(addon);
    if (coupon && coupon.addon_discount && isAddonEligibleForDiscount(addon, coupon)) {
        unitPrice = parseFloat(helpers.getDiscountedPrice(unitPrice, coupon.addon_discount));
    }
    return unitPrice;
}

function getAddonLineTotal(addon, multiplier, coupon, getters) {
    return getDiscountedAddonUnitPrice(addon, coupon, getters) * (parseInt(addon.qty) || 1) * multiplier;
}

// Mondopoint shoe sizes  
const MO_options = [];
for (var mo = 15; mo <= 34; mo = mo + 0.5) {
    MO_options.push(mo);
}

// US Kids shoe sizes
const US_kids_options = [];
for (var us_k = 7.5; us_k <= 13.5;  us_k = us_k + 0.5) {
    US_kids_options.push(us_k + '(Kids)');
}
for (var us_mk = 1; us_mk <= 5.5; us_mk = us_mk + 0.5) {
    US_kids_options.push(us_mk);
}

// US Men shoe sizes
const US_M_options = [];
for (var us_m = 5.5; us_m <= 15; us_m = us_m + 0.5) {
    US_M_options.push(us_m);
}

// US Women shoe sizes
const US_W_options = [];
for (var us_w = 4; us_w <= 12; us_w = us_w + 0.5) {
    US_W_options.push(us_w);
}

// EU shoe sizes
// EU Women shoe sizes
const EU_W_options = [];
for (var eu_w = 35; eu_w <= 42.5; eu_w = eu_w + 0.5) {
    EU_W_options.push(eu_w);
}
// EU Men shoe sizes
const EU_M_options = [];
for (var eu_m = 38; eu_m <= 50.5; eu_m = eu_m + 0.5) {
    EU_M_options.push(eu_m);
}
// EU kids shoe sizes
const EU_kids_options = [];
for (var eu_k = 23.5; eu_k <= 37; eu_k = eu_k + 0.5) {
    EU_kids_options.push(eu_k);
}

// EU Women shoe sizes
const UK_W_options = [];
for (var uk_w = 2; uk_w <= 10; uk_w = uk_w + 0.5) {
    UK_W_options.push(uk_w);
}
// UK men shoe sizes
const UK_M_options = [];
for (var uk_m = 5; uk_m <= 15; uk_m = uk_m + 0.5) {
    UK_M_options.push(uk_m);
}
// UK kids shoe sizes
const UK_kids_options = [];
for (var uk_k = 6.5; uk_k <= 13.5; uk_k = uk_k + 0.5) {
    UK_kids_options.push(uk_k + '(Kids)');
}
for (var uk_km = 1; uk_km <= 4.5; uk_km = uk_km + 0.5) {
    UK_kids_options.push(uk_km);
}

var base_url = window.location.origin === 'https://blacktiewp.makeitreal.live' ? "https://staging.blacktieskis.com" : "https://booknow.blacktieskis.com";
// //here can add local hosts, rest host will render data from live site (i.e wordpress hosts)
var allowed_hosts = ["https://import.blacktieskis.com", "https://uat.blacktieskis.com", "https://test.blacktieskis.com", "http://black-tie.test", "http://blacktie.devs", "http://blacktie.test", "https://staging.blacktieskis.com", "https://dev.blacktieskis.com", "http://127.0.0.1:8000", "https://booknow.blacktieskis.com","https://renterdb.blacktieskis.com"]
if(allowed_hosts.includes(window.location.origin)){
    base_url = window.location.origin;
    console.log({'chaning_base_url': base_url})
}
console.log({'current_base_url': base_url})



const getDefaultState = () => {

    return{
        previousRouteName: null,
        storage_loaded: false,
        from_abandoned_link: 'no',
        abandoned_attempt_email: 0,
        resort_change_clicked: false, //to avoid auto open delivery dropdown.
        base_url: base_url,
        step: 1,
        auth_type: 'login',
        auth_user: helpers.getUser(),
        isLoading: false,
        cut_of_time: "2:00 PM",
        stores: [],
        langs: [],
        resorts: [],
        all_resorts: [],
        live_site: false,
        currency_sign: '$',
        delivery_fee: 0.00, //delivery fee will not apply on pickup.
        location_taxes: [],
        resort_policies: [],
        renters: [],
        packages: [],
        repeat_renters: [],
        delivery_times: [],
        min_booking_days: 0,
        min_booking_days_text: 0,
        season_start_at: null,
        season_end_at: null,
        package_limitations: null,
        has_tots_packages: false,
        resort_is_krf: false,
        krf_package_types: [],
        form: {
            'resort_id': null,
            'store_id': null,
            'portal_url_code': null,
            'accommodation': '',
            'is_pickup': 0,
            'delivery_date': null,
            'delivery_time': null,
            'first_day_skiing': null,
            'return_date': null,
            'first_name': '',
            'last_name': '',
            'email': '',
            'dial_code': 1,
            'phone': '',
            'address': '',
            'address2': '',
            'city': '',
            'state': '',
            'zip_code': '',
            'country': '',
            'international_customer': false,
        },
        cart: {
            'packages': [],
            'invoice_addons': [],
            'tax_total': 0,
            'delivery_tax': 0,
            'non_tax_total': 0,
            'discount_amount': 0,
            'discounted_subtotal': 0,
            'discounted_package_total': 0,
            'subtotal': 0,
            'total': 0,
        },
        filter: {
            'sort': '',
            'show_inactive_resorts':0
        },
        selected_skis: [],
        selected_snowboards: [],
        app_name: 'Black Tie Ski Rental',
        adultClothing: [],
        jrClothing: [],
        packageAddons: [],
        notSkierAddons: [],
        portal: null,
        coupon: null,
        MO_options: MO_options,
        US_kids_options: US_kids_options,
        US_M_options: US_M_options,
        US_W_options: US_W_options,

        EU_kids_options: EU_kids_options,
        EU_M_options: EU_M_options,
        EU_W_options: EU_W_options,

        UK_kids_options: UK_kids_options,
        UK_M_options: UK_M_options,
        UK_W_options: UK_W_options,
    }
}

// initial state
const state = getDefaultState()

export default new Vuex.Store({
    state: state,
    mutations: {
        setPreviousRouteName(state, name) {
            state.previousRouteName = name;
        },

        SET_STEP1_PARAMS(state, params) {
            state.form.step1_params = params;
        },

        SET_DATA(state, data) {
            state.all_resorts = data.resorts;
            state.resorts = data.resorts.filter(item => item.is_active === 1);
            state.live_site = data.live_site;
        },
        SET_RESORT_DATA(state, data) {
            state.stores = data.stores;
            state.langs = data.langs;
            state.resort_policies = data.resort_policies;
            state.location_taxes = data.location_taxes;
            state.delivery_tax = data.delivery_tax //delivery fee will not apply on pickup.
            state.currency_sign = data.currency_sign;
            state.season_start_at = data.season_start_at ? new Date(moment(data.season_start_at)) : (new Date()).setDate((new Date()).getDate() - 1);
            state.season_end_at = new Date(moment(data.season_end_at));
            state.package_limitations = data.package_limitations;
            state.cut_of_time = moment(data.cut_of_time, "h:mm A").format('hh:mm A');
        },
        SET_DELIVERY_TIMES(state, data) {
            state.min_booking_days = data.min_booking_days - 1;
            state.min_booking_days_text = data.min_booking_days_text;
            state.delivery_times = data.delivery_times;
        },

        SET_PORTAL(state, portal) {
            state.portal = portal;
            state.form.portal_url_code = portal ? portal.url_code : null;
        },

        SET_COUPON(state, coupon) {
            state.coupon = coupon
            localStorage.setItem('coupon', JSON.stringify(coupon))
        },

        SET_ACCOMMODATION(state, value){
            state.form.accommodation = value;
        },


        SET_RESORT_ID(state, value) {
            state.form.resort_id = value;
            state.form.is_pickup = 0;
            state.form.store_id = null;
            state.form.delivery_date = null;
            state.form.delivery_time = null;
            state.form.return_date = null;
        },
        SET_RESORT_PORTAL(state, data) {
            state.form.resort_id = data.resort_id;
            state.form.is_pickup = data.store_id?1:0;
            state.form.store_id = data.store_id?data.store_id:null;
            state.form.delivery_date = null;
            state.form.delivery_time = null;
            state.form.return_date = null;
        },
        SET_DELIVERY_DATE(state, value) {
            state.form.delivery_date = value;
            state.form.delivery_time = null;
            state.form.return_date = null;
        },
        SET_FIRST_DAY_SKIING(state) {

            let delivery_date = state.form.delivery_date;
            let delivery_time = state.form.delivery_time;

            let time_format = 'hh:mm A';
            let time = moment(delivery_time, time_format);
            let cut_of_time = moment(state.cut_of_time, time_format);

            // If before 2:00 pm, it is same day as deliver date
            if (time.isBefore(cut_of_time)) {
                state.form.first_day_skiing = delivery_date;
            }
            // If after 2:00 pm, it is for next day
            else {
                //next day
                let first_day_skiing = moment(moment(delivery_date), "MM-DD-YYYY").add(1, 'days');
                state.form.first_day_skiing = moment(first_day_skiing).format('MM/DD/YYYY');
            }
        },
        SET_DELIVERY_TIME(state, value) {
            state.form.delivery_time = value;
            state.form.return_date = null;
        },
        SET_DELIVERY_TIME_ONLY(state, value) {
            state.form.delivery_time = value;
        },
        SET_RETURN_DATE(state, value) {
            state.form.return_date = value;
        },


        SET_SELECTED_SKIS(state, value) {
            state.selected_skis = value;
        },

        SET_SELECTED_SNOWBOARDS(state, value) {
            state.selected_snowboards = value;
        },

        SET_REPEAT_RENTERS(state, data) {
            state.repeat_renters = data.renters;
        },

        SET_PACKAGES(state, data) {
            state.packages = data.packages;
            state.resort_is_krf = data.resort_is_krf;
            state.krf_package_types = data.krf_package_types;
            state.has_tots_packages = !!data.has_tots_packages;
            if(state.packages && state.packages.length > 0){
                state.packages.forEach(function (pkg, key) {
                    pkg.qty = pkg.qty ? pkg.qty : 1;
                });
            }
        },


        SET_RENTERS(state, data) {
            state.renters = data;
        },

        SET_ADULT_CLOTHING(state, data) {
            state.adultClothing = data.adultClothing;
        },

        SET_JR_CLOTHING(state, data) {
            state.jrClothing = data.jrClothing;
        },
        SET_PACKAGE_ADDONS(state, data) {
            state.packageAddons = data.packageAddons;
        },
        SET_NOT_SKIER_ADDONS(state, data) {
            state.notSkierAddons = data.notSkierAddons;
        },

        SET_CART_INVOICE_ADD_ONS(state, addons){
            state.cart.invoice_addons = addons
        },

        SET_CART_NON_TAX_TOTAL(state, amount) {
            state.cart.non_tax_total = amount;
        },
        SET_CART_DISCOUNT_AMOUNT(state, amount) {
            state.cart.discount_amount = amount;
        },
        SET_CART_SUBTOTAL(state, amount) {
            state.cart.subtotal = amount;
        },
        SET_CART_DISCOUNTED_SUBTOTAL(state, amount) {
            state.cart.discounted_subtotal = amount;
        },
        SET_CART_DISCOUNTED_PACKAGE_TOTAL(state, amount) {
            state.cart.discounted_package_total = amount;
        },
        SET_CART_TAX_TOTAL(state, amount) {
            state.cart.tax_total = amount;
        },
        SET_CART_DELIVERY_TAX(state, amount) {
            state.cart.delivery_tax = amount;
        },
        SET_CART_TOTAL(state, amount) {
            state.cart.total = amount;
        },
        SET_STEP(state, step) {
            state.step = step;
        }
    },
    actions: {
        updateStep({state, commit, dispatch}, {step}) {
            commit('SET_STEP', step)
        },
        setLoading({state}, {loading}) {
            state.isLoading = loading;
        },

        setResortID({state, commit, dispatch}, {resort_id}){
            commit('SET_RESORT_ID', resort_id)
            dispatch('getResortData');
            state.packages = []; //needs to reset if rental length get changed it effects on prices.
            state.cart.packages = []; //needs to reset if rental length get changed it effects on prices.
        },
        setResortPortal({state, commit, dispatch}, {data}){
            commit('SET_RESORT_PORTAL', data)
            dispatch('getResortData');
            state.packages = []; //needs to reset if rental length get changed it effects on prices.
            state.cart.packages = []; //needs to reset if rental length get changed it effects on prices.
        },
        setResortStore({state, commit, dispatch}, {data}){
            commit('SET_RESORT_PORTAL', data)
            dispatch('getResortDataSelect');
            state.packages = []; //needs to reset if rental length get changed it effects on prices.
            state.cart.packages = []; //needs to reset if rental length get changed it effects on prices.
        },

        setAuthModalType({state}, value){
            state.auth_type = value
        },

        setDeliveryDate({state, commit, dispatch}, {delivery_date}){
            commit('SET_DELIVERY_DATE', delivery_date)
            dispatch('fetchDeliveryTimes');
        },

        setAccommodation({state, commit}){
            let accommodation = '';
            let store = state.stores.find(store => store.id === state.form.store_id);
            if(store){
                accommodation = store.address ? store.address : store.name;
            }else if(state.portal){
                accommodation = state.portal.accommodation;
            }else{
                accommodation = '';
            }
            commit('SET_ACCOMMODATION', accommodation)
        },

        chekPortalCookie({state, dispatch}) {
            if(state.form.portal_url_code){
                DataService.chekPortalCookie(state.form.portal_url_code)
                    .then(response => {
                        let is_portal_active = response.data.data.is_portal_active;

                        if(is_portal_active === false){
                            dispatch('resetStorageAndStore');
                            router.push({'name': 'Step1'})
                            swal({
                                title: "SESSION EXPIRED!",
                                text: 'Your Discount Session expired please try another!',
                                // type: "warning",
                                imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                                showConfirmButton: true
                            });
                        }
                    })
                    .catch(error => {
                    });
            }
        },

        fetchAllResorts({commit, state}) {
            state.isLoading = true;
            DataService.getAllResorts(state.filter)
                .then(response => {
                    commit('SET_DATA', response.data.data)
                    // helpers.initializeGTranslate(response.data.data.gtranslate_settings)
                    state.isLoading = false;
                })
                .catch(error => {
                    state.isLoading = false;
                    console.log('There wan an error:', error.response)
                });
        },

        setStep1Params({commit, state}, value){
            if(value || !state.form.step1_params){
                commit('SET_STEP1_PARAMS', value)
            }
        },

        getResortData({commit, state, dispatch}) {
            state.isLoading = true;
            DataService.getResortData(state.form.resort_id)
                .then(response => {
                    commit('SET_RESORT_DATA', response.data.data);
                    dispatch('fillPortalData');
                    EventBus.$emit('resort-data-fetched');
                    state.isLoading = false;
                })
                .catch(error => {
                    state.isLoading = false;
                    console.log('There wan an error:', error)
                });
        },
        getResortDataSelect({commit, state, dispatch}) {
            state.isLoading = true;
            DataService.getResortDataSelect(state.form.resort_id,state.form.is_pickup,state.form.store_id)
                .then(response => {
                    commit('SET_RESORT_DATA', response.data.data);
                    dispatch('fillPortalData');
                    EventBus.$emit('resort-data-fetched');
                    state.isLoading = false;
                })
                .catch(error => {
                    state.isLoading = false;
                    console.log('There wan an error:', error)
                });
        },

        putDataInStorage({state}, from_wp = false) {
            localStorage.removeItem('store_state')
            localStorage.setItem('store_state', JSON.stringify(state))

            if(from_wp){
                return DataService.updateOrCreateUncompletedReservation(window.location.href, state.form.resort_id, JSON.stringify(state))
            }else{
                let authUser = helpers.getUser();
                if(authUser) {
                    return DataService.updateOrCreateUncompletedReservation(window.location.href, state.form.resort_id, JSON.stringify(state))
                        .then(response => {
                            console.log('Storage Saved')
                        })
                        .catch(error => {
                            console.log('There wan an error saving storage:', error.response)
                        });
                }
            }
        },

        setDataFromStorage({state, dispatch, commit}) {
            state.isLoading = true;
            let authUser = helpers.getUser();
            const urlParams = new URLSearchParams(window.location.search);
            const uc_id = urlParams.get('ucid'); // johnny

            let prevUrl = document.referrer ? new URL(document.referrer) :null;
            let prev_origin =prevUrl ? prevUrl.origin : null;
            let my_origin = window.location.origin;
            if (my_origin !== prev_origin && uc_id && prev_origin) {
                dispatch('setDataFromDB', { uc_id: uc_id, load_from_abandoned: true })
            }else{
                if (urlParams.has('db_storage')){
                    //login and than set data from db
                    DataService.loginByKey(urlParams.get('db_storage'))
                        .then(res => {
                            helpers.setAccessToken(res.data.data.access_token);
                            axios.defaults.headers.common['Authorization'] = localStorage.getItem('getToken')
                            helpers.setUser(res.data.data.user);
                            helpers.clearLocalStorage();
                            let user = res.data.data.user;
                            state.auth_user = helpers.getUser();
                            if(user){
                                state.form.first_name = user.first_name;
                                state.form.last_name = user.last_name;
                                state.form.lang = user.lang;
                                state.form.email = user.email;
                                state.form.phone = user.phone;
                                state.form.dial_code =  user.dial_code;
                            }
                            dispatch('setDataFromDB', { uc_id: null, load_from_abandoned: true })
                        })
                        .catch(error => {
                            state.storage_loaded = true;
                            dispatch('setLoading',{'loading': false});
                            let er = error.response ? error.response.data.message : error;
                            console.log(er);
                            swal({
                                title: "Error!",
                                text: "Login Session Expired!",
                                // type: "error",
                                imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                                showConfirmButton: true
                            });
                        })

                    state.abandoned_attempt_email =  urlParams.has('attempt') ? urlParams.get('attempt') : 0;
                    state.from_abandoned_link = 'yes';

                }else{
                    console.log('fetching from local storage');
                    dispatch('setDataFromDB', { uc_id: null, load_from_abandoned: false });
                    if (localStorage.getItem('store_state')) {
                        let data = JSON.parse(localStorage.getItem('store_state'));
                        if (data.resorts && data.resorts.length > 0) {
                            Object.keys(data).forEach(function (key) {
                                if(key !== 'storage_loaded'){
                                    state[key] = data[key]
                                }
                            });
                            state.isLoading = false;
                            state.storage_loaded = true;

                        } else {
                            state.storage_loaded = true;
                            dispatch('fetchAllResorts');
                        }
                    } else {
                        state.storage_loaded = true;
                        dispatch('fetchAllResorts');
                    }
                }
            }

        },

        setDataFromDB({state, dispatch, getters},payload){
            const { uc_id, load_from_abandoned } = payload;
            console.log(load_from_abandoned, uc_id);
            DataService.getUncompletedReservation(uc_id)
                .then(response => {
                    let uncompleted_reservation = response.data.data.uncompleted_reservation;
                    let have_recent_reservation = response.data.data.have_recent_reservation;
                    if(load_from_abandoned){
                        console.log('loading from db')
                        if(uncompleted_reservation){
                            let db_storage_data = JSON.parse(uncompleted_reservation.data);
                            if (db_storage_data.resorts && db_storage_data.resorts.length > 0) {
                                Object.keys(db_storage_data).forEach(function (key) {
                                    if(key !== 'authUser' && key !== 'from_abandoned_link' && key!== 'previousRouteName' && key !== 'abandoned_attempt_email' && key !== 'storage_loaded'){
                                        state[key] = db_storage_data[key]
                                    }
                                });
                                let authUser = helpers.getUser();
                                state.auth_user = authUser;
                                state.isLoading = false;
                                state.storage_loaded = true;
                                dispatch('putDataInStorage');
                                if(authUser && uc_id){
                                    console.log('auth user log');
                                    router.push({'name': 'Step3'})
                                }
                            } else {
                                state.storage_loaded = true;
                                dispatch('fetchAllResorts');
                            }
                        }
                        else {
                            state.storage_loaded = true;
                            dispatch('fetchAllResorts');
                        }

                    }else{
                        console.log('loading from local')
                        state.storage_loaded = true;
                    }

                    if(have_recent_reservation ){
                        swal({
                                title: "Are you sure?",
                                text: "It appears that you already have a reservation for "+have_recent_reservation+". Would you like to create a new one?",
                                showCancelButton: true,
                                cancelButtonText: "No",
                                confirmButtonText: "Yes",
                                imageUrl: "/images/warning-alert.png",
                                confirmButtonColor: "#DD6B55",
                                closeOnConfirm: true,
                                closeOnCancel: true
                            },
                            function (isConfirm) {
                                if (isConfirm) {
                                    if (!state.form.resort_id) {
                                        router.push(getters.getStep1Route);
                                    }
                                }else{
                                    if(uncompleted_reservation){
                                        DataService.deleteUncompletedReservation(uncompleted_reservation.id).then(
                                            response => {
                                                location.href = '/frontend/reservations';
                                            }
                                        )
                                    }else{
                                        location.href = '/frontend/reservations';
                                    }
                                }
                            });
                    }


                })
                .catch(error => {
                    state.storage_loaded = true;
                    dispatch('fetchAllResorts');
                });

        },

        fetchDeliveryTimes({commit, state, dispatch}) {
            if(state.form.resort_id && state.form.delivery_date){
                state.isLoading = true;
                DataService.getResortDeliveryTimes(state.form.resort_id, state.form.delivery_date, state.form.is_pickup, state.form.portal_url_code, state.form.store_id)
                    .then(response => {
                        commit('SET_DELIVERY_TIMES', response.data.data)
                        state.isLoading = false;
                    })
                    .catch(error => {
                        state.isLoading = false;
                        console.log('There wan an error:', error.response)
                    });
            }
        },

        fetchRepeatRenters({commit, state, getters, dispatch}) {
            if(state.auth_user){
                state.isLoading = true;
                let data = {
                    'delivery_date': state.form.delivery_date,
                    'delivery_time': state.form.delivery_time,
                    'resort_id': state.form.resort_id,
                    'portal_url_code': state.form.portal_url_code,
                    'is_pickup':state.form.is_pickup,
                    'store_id':state.form.store_id,
                }
                return DataService.getCustomerRepeatRenters(data)
                    .then(function (response) {
                        state.isLoading = false;
                        commit('SET_REPEAT_RENTERS', response.data.data)
                        return response;
                    })
                    .catch(function (error) {
                        state.isLoading = false;
                        const errMsg = error.response ? error.response.data.message : 'Something went wrong, please try again.';
                        swal({
                            title: "Error!",
                            text: errMsg,
                            // type: "error",
                            imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                            showConfirmButton: true
                        });
                        if(error.response && error.response.data.additionalData){
                            if(error.response.data.additionalData.deliveryPopup){
                                dispatch('fetchDeliveryTimes');
                                commit('SET_DELIVERY_TIME_ONLY', null);
                            }
                        }
                        throw error;
                    });
            } else {
                return Promise.resolve();
            }
        },

        fetchPackages({commit, state, getters, dispatch}, fromDetailBar = false) {
            state.isLoading = true;

            state.coupon = null;
            dispatch('applyGlobalCoupon').then(() => {
                DataService.getPackages(state.form.resort_id, getters.getRentalLength, state.form.delivery_date)
                    .then(function (response) {
                        state.isLoading = false;
                        commit('SET_PACKAGES', response.data.data)
                        if(fromDetailBar){
                            dispatch('updateDataAfterDateChanged')
                        }
                        dispatch('fetchRepeatRenters')
                    })
                    .catch(function (error) {
                        state.isLoading = false;
                    });

            }); //bottom code should run after completion of this function
        },

        fetchPackageAddons({commit, state, getters, dispatch}, set_dw = false) {
            state.isLoading = true;
            let package_resort_ids = state.renters.map(renter => renter.package_resort_id);
            DataService.getPackageAddons(state.form.resort_id, package_resort_ids, getters.getRentalLength, state.form.delivery_date, state.form.delivery_time,state.form.portal_url_code,state.form.is_pickup,state.form.store_id)
                .then(function (response) {
                    state.isLoading = false;
                    commit('SET_PACKAGE_ADDONS', response.data.data)
                    commit('SET_NOT_SKIER_ADDONS', response.data.data)
                    if(set_dw){
                        dispatch('setDWAddonToAllRenters')
                    }
                })
                .catch(function (error) {
                    state.isLoading = false;
                    console.log(error)
                    const errorMsg = error.response ? error.response.data.message : 'Something went wrong, please try again.';
                    swal({
                        title: "Error!",
                        text: errorMsg,
                        // type: "error",
                        imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                        showConfirmButton: true
                    });
                    if(error.response.data.additionalData){
                        if(error.response.data.additionalData.deliveryPopup){
                            dispatch('fetchDeliveryTimes');
                            commit('SET_DELIVERY_TIME_ONLY', null);
                        }
                    }else{
                        if(router.currentRoute.name !== 'Step1'){
                            NProgress.start();
                            router.push({'name': 'Step1'})
                        }
                    }

                });
        },

        setDWAddonToAllRenters({state, getters,dispatch}){
            let dw =state.packageAddons && state.packageAddons.find(addon=> addon.name === 'Damage Waiver');
            if(dw){
                getters.getAddonRenters(dw.package_resort_ids).forEach(function(renter) {
                    if(renter.add_ons){
                        if (!renter.add_ons.some(addon => addon.id === dw.id)) {
                            renter.add_ons.push(dw); // Initialize with qty of 1
                            dispatch('updateGTMLayer', {'event': 'add_to_cart', 'item': dw, 'item_type': 'add-on'})
                            dispatch('klaviyoAddedToCart', {'item': dw, 'item_type': 'add-on'})
                        }
                    }

                });
                dispatch('setSummaryPage');
            }
        },

        fetchClothing({commit, state}) {
            state.isLoading = true;
            DataService.getClothing(state.form.resort_id, state.form.delivery_date)
                .then(function (response) {
                    state.isLoading = false;
                    commit('SET_ADULT_CLOTHING', response.data.data)
                    commit('SET_JR_CLOTHING', response.data.data)
                })
                .catch(function (error) {
                    state.isLoading = false;
                });
        },


        fetchPortalData({commit, state, dispatch, getters}, {url_code}){
            state.isLoading = true;
            dispatch('resetStorageAndStore');
            DataService.fetchPortalData(url_code)
                .then(response => {
                    let portal = response.data.data.portal;
                    let have_pickup = response.data.data.have_pickup;
                    commit('SET_PORTAL', portal);
                    if(portal && portal.resort_id){

                        //if have pick_up need to unset resort, so user can set delivery or pickup option
                        // if(!have_pickup){
                            dispatch('setResortPortal', {data:portal});
                            dispatch('fetchAllResorts');
                        // }else{
                        //     dispatch('fillPortalData');
                        // }

                    }
                    state.isLoading = false;
                })
                .catch(error => {
                    state.isLoading = false;
                });
        },

        fillPortalData({commit,state, dispatch}){
            let portal = state.portal;
            if(portal){
                let portal_delivery_date = portal.delivery_date ? moment(portal.delivery_date).format('MM/DD/YYYY') : null;
                if(portal_delivery_date && moment(portal_delivery_date).isAfter(new Date(state.season_start_at))){
                    dispatch('setDeliveryDate',{'delivery_date': portal_delivery_date})
                    commit('SET_DELIVERY_TIME', portal.delivery_time)


                    //set first day skiing if date is equal or after delivery date.
                    let portal_first_ski_date = portal.first_ski_date ? moment(portal.first_ski_date).format('MM/DD/YYYY') : null;
                    if(portal_first_ski_date && moment(portal_first_ski_date).isSameOrAfter(moment(state.form.delivery_date).format('MM/DD/YYYY'))){
                        state.form.first_day_skiing = portal_first_ski_date;
                    }else{
                        commit('SET_FIRST_DAY_SKIING');
                    }

                    if(state.form.delivery_date && state.form.first_day_skiing && state.form.delivery_time){

                    }else{
                        if(state.form.resort_id && state.form.delivery_date){
                            //only open if resort id and delivery time is added but delivery_time is missing
                            $("#delivery-drop-down").click();
                        }
                    }

                    //set return date from portal if there is.
                    let portal_last_ski_date = portal.last_ski_date ? moment(portal.last_ski_date).format('MM/DD/YYYY') : null;

                    if(portal_last_ski_date && moment(portal_last_ski_date).isSameOrAfter(moment(state.form.first_day_skiing).format('MM/DD/YYYY'))){
                        commit('SET_RETURN_DATE', portal_last_ski_date)
                    }
                }
            }
        },
        clearDeliveryTimeIfWrong({state, commit}){
           let  delivery_times = Object.entries(state.delivery_times);
           let delivery_time = delivery_times.find(time => {
                return time[0] === state.form.delivery_time;
           });

           if(!delivery_time){
               commit('SET_DELIVERY_TIME', null);
           }

           //reset ages of renters
            let renters = state.renters;

            renters.forEach(function(renter){
                renter.is_completed = false;
            })
        },

        applyGlobalCoupon({commit, state, getters, dispatch}) {
            state.isLoading = true;
            let reservation = {
                'resort_id': state.form.resort_id,
                'delivery_date': state.form.delivery_date,
                'rental_length': getters.getRentalLength,
                'portal_url_code': state.form.portal_url_code,
            };
            return DataService.applyGlobalCoupon(reservation)
                .then(response => {
                    let couponData = response.data.data.coupon;
                    if (response.data.data.applicable_addons) {
                        couponData.applicable_addons = response.data.data.applicable_addons;
                    }
                    commit('SET_COUPON', couponData);
                    state.isLoading = false;
                })
                .catch(error => {
                    state.isLoading = false;
                });
        },

        applyCoupon({commit, state, getters, dispatch}, coupon_code) {
            if (state.coupon && state.coupon.code === coupon_code) {
                swal({
                    title: "Warning!",
                    text: 'This Coupon is Already Applied.',
                    // type: "warning",
                    imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                    showConfirmButton: true
                });
            } else {
                state.isLoading = true;
                let reservation = {
                    'resort_id': state.form.resort_id,
                    'delivery_date': state.form.delivery_date,
                    'rental_length': getters.getRentalLength,
                    'coupon_code': coupon_code,
                    'email' : state.auth_user ? state.auth_user.email : '',
                    'renters': state.renters || []
                };
                DataService.applyCoupon(reservation)
                    .then(response => {
                        let couponData = response.data.data.coupon;
                        // Add applicable packages information if available
                        if (response.data.data.applicable_packages) {
                            couponData.applicable_packages = response.data.data.applicable_packages;
                        }
                        if (response.data.data.applicable_addons) {
                            couponData.applicable_addons = response.data.data.applicable_addons;
                        }
                        commit('SET_COUPON', couponData);
                        dispatch('setSummaryPage');
                        state.isLoading = false;
                        swal({
                            title: "Success!",
                            text: 'Coupon Applied.',
                            type: "success",
                            showConfirmButton: true
                        });
                    })
                    .catch(error => {
                        state.isLoading = false;
                        const errMsg = error.response ? error.response.data.message : 'Something went wrong, please try again.';

                        swal({
                            title: "ALERT!",
                            text: errMsg,
                            // type: "error",
                            imageUrl: "/images/warning-alert.png",  // Replace with the path to your custom image
                            showConfirmButton: true
                        });
                    });
            }
        },

        //if update from step3, or step4, 5
        updateDataAfterDateChanged({commit, state, getters, dispatch}){
            let limitation_age = getters.getLimitationAge;

            state.renters.forEach(function(renter){

                let pkg = state.packages.find(pkg => pkg.package_resort_id === renter.package_resort_id);

                if(pkg){
                    renter.package_price = pkg.price;
                    renter.package_max_price = pkg.max_price;
                }else{
                    renter.kid_free = false;
                    renter.package_resort_id = null;
                    renter.free_package_resort_id = null;
                    renter.package_id = null;
                    renter.package_name = '';
                    renter.package_price = 0;
                    renter.is_completed = false;
                    renter.package_max_price = null;
                }

                renter.number_of_days = getters.getRentalLength;

                //reset krf, bcz of kids are no longer meets krf requirements.
                if(state.resort_is_krf && renter.number_of_days < 5 && renter.age < limitation_age){
                    renter.kid_free = false;
                    renter.package_resort_id = null;
                    renter.free_package_resort_id = null;
                    renter.package_id = null;
                    renter.package_name = '';
                    renter.package_price = 0;
                    renter.is_completed = false;
                    renter.package_max_price = null;
                }
            })
            dispatch('setSummaryPage');
            dispatch('putDataInStorage');
        },

        setSummaryPage({commit, state, getters}) {
            let package_total = 0;
            let tax_total = 0;
            let delivery_tax = 0;
            let subtotal = 0;
            let non_tax_total = 0;
            let discount_amount = 0;
            let discount_percentage = state.coupon ? state.coupon.discount : 0;
            let addon_discount_percentage = state.coupon && state.coupon.addon_discount ? parseFloat(state.coupon.addon_discount) : 0;

            if(state.renters && state.renters.length > 0){
                state.renters.forEach(function (renter) {
                    if (state.coupon && isPackageEligibleForDiscount(renter, state.coupon)) {
                        discount_percentage = state.coupon ? state.coupon.discount : 0;
                    }
                    //set clothing
                    let clothing = getters.getRenterClothing(renter.clothing_resort_id, renter.age)
                    renter.clothing_name = clothing.name;
                    renter.clothing_price = clothing.price;


                    //calcualte non_tax_total (use discounted amounts when add-on coupon applies)
                    if(renter.add_ons && renter.add_ons.length > 0){
                        renter.add_ons.forEach(function (addon) {
                            if (addon.tax_free) {
                                let multiplier = addon.pricing === 'one_time' ? 1 : renter.number_of_days;
                                non_tax_total += getAddonLineTotal(addon, multiplier, state.coupon, getters);
                            }
                        })
                    }


                    //calculate discount_amount
                    let renter_package_total = renter.package_price * renter.number_of_days;
                    package_total += renter_package_total;

                    // Only apply discount if package is eligible
                    if (state.coupon && isPackageEligibleForDiscount(renter, state.coupon)) {
                        discount_amount += helpers.calc_tax_amount(renter_package_total, discount_percentage);
                    }

                    if (addon_discount_percentage > 0) {
                        if (renter.add_ons && renter.add_ons.length > 0) {
                            renter.add_ons.forEach(function (addon) {
                                if (!isAddonEligibleForDiscount(addon, state.coupon)) {
                                    return;
                                }
                                let addon_line_total = 0;
                                if (addon.pricing === 'one_time') {
                                    addon_line_total = getters.getAddonDailyPrice(addon) * parseInt(addon.qty);
                                } else {
                                    addon_line_total = getters.getAddonDailyPrice(addon) * parseInt(addon.qty) * renter.number_of_days;
                                }
                                discount_amount += helpers.calc_tax_amount(addon_line_total, addon_discount_percentage);
                            });
                        }

                        if (renter.clothing_resort_id && renter.clothing_price) {
                            let clothing_total = renter.clothing_price * renter.number_of_days;
                            discount_amount += helpers.calc_tax_amount(clothing_total, addon_discount_percentage);
                        }
                    }


                    //calculate total
                    subtotal += getters.getRenterTotal(renter)
                });
            }

            let invoice_addons = getters.getInvoiceAddons();
            commit('SET_CART_INVOICE_ADD_ONS', invoice_addons);
            //calcualte non_tax_total (use discounted amounts when add-on coupon applies)
            if(invoice_addons && invoice_addons.length > 0){
                invoice_addons.forEach(function (invoice_addon) {
                    if (invoice_addon.tax_free) {
                        let multiplier = invoice_addon.pricing === 'one_time' ? 1 : getters.getRentalLength;
                        non_tax_total += getAddonLineTotal(invoice_addon, multiplier, state.coupon, getters);
                    }
                })
            }

            subtotal += getters.getAddonsDailyPriceTotal(getters.invoiceNonPercentAddons) * getters.getRentalLength;
            subtotal += getters.getAddonsDailyPriceTotal(getters.invoiceOneTimeAddons);

            if (addon_discount_percentage > 0) {
                if (getters.invoiceNonPercentAddons && getters.invoiceNonPercentAddons.length > 0) {
                    getters.invoiceNonPercentAddons.forEach(function (invoice_addon) {
                        if (!isAddonEligibleForDiscount(invoice_addon, state.coupon)) {
                            return;
                        }
                        let addon_line_total = getters.getAddonDailyPrice(invoice_addon) * parseInt(invoice_addon.qty) * getters.getRentalLength;
                        discount_amount += helpers.calc_tax_amount(addon_line_total, addon_discount_percentage);
                    });
                }

                if (getters.invoiceOneTimeAddons && getters.invoiceOneTimeAddons.length > 0) {
                    getters.invoiceOneTimeAddons.forEach(function (invoice_addon) {
                        if (!isAddonEligibleForDiscount(invoice_addon, state.coupon)) {
                            return;
                        }
                        let addon_line_total = getters.getAddonDailyPrice(invoice_addon) * parseInt(invoice_addon.qty);
                        discount_amount += helpers.calc_tax_amount(addon_line_total, addon_discount_percentage);
                    });
                }
            }


            subtotal += getters.getPercentAddonsTotal(getters.invoicePercentAddons, (subtotal-discount_amount));
            let discounted_sub_total = subtotal-discount_amount;
            let taxable_subtotal = discounted_sub_total - non_tax_total;

            if(state.location_taxes && state.location_taxes.length > 0){
                state.location_taxes.forEach(function(location_taxe){
                    tax_total += helpers.calc_tax_amount(taxable_subtotal, location_taxe.percentage)
                })
            }

            // Per-add-on tax exclusion delta (Whistler-only feature).
            // Pure no-op when no add-on has `excluded_tax_ids` set (every
            // existing add-on across every resort today). For each location
            // tax we subtract (excluded_addon_revenue * tax.percentage)
            // so the cart shows the same tax the backend will actually charge.
            if (state.location_taxes && state.location_taxes.length > 0) {
                state.location_taxes.forEach(function (location_taxe) {
                    let excluded_revenue = 0;

                    if (state.renters && state.renters.length > 0) {
                        state.renters.forEach(function (renter) {
                            if (!renter.add_ons || renter.add_ons.length === 0) return;
                            renter.add_ons.forEach(function (addon) {
                                if (addon.tax_free) return;
                                let excluded = addon.excluded_tax_ids;
                                if (!Array.isArray(excluded) || excluded.length === 0) return;
                                if (excluded.map(Number).indexOf(Number(location_taxe.id)) === -1) return;

                                let multiplier = addon.pricing === 'one_time' ? 1 : (renter.number_of_days || 0);
                                excluded_revenue += getAddonLineTotal(addon, multiplier, state.coupon, getters);
                            });
                        });
                    }

                    if (invoice_addons && invoice_addons.length > 0) {
                        invoice_addons.forEach(function (invoice_addon) {
                            if (invoice_addon.tax_free) return;
                            let excluded = invoice_addon.excluded_tax_ids;
                            if (!Array.isArray(excluded) || excluded.length === 0) return;
                            if (excluded.map(Number).indexOf(Number(location_taxe.id)) === -1) return;

                            let multiplier = invoice_addon.pricing === 'one_time' ? 1 : getters.getRentalLength;
                            excluded_revenue += getAddonLineTotal(invoice_addon, multiplier, state.coupon, getters);
                        });
                    }

                    if (excluded_revenue > 0) {
                        tax_total -= helpers.calc_tax_amount(excluded_revenue, location_taxe.percentage);
                    }
                });
            }

            //delivery fee will not apply on pickup.
            if(state.delivery_tax && !state.form.is_pickup){
                if(state.delivery_tax.type === 'percent'){
                    delivery_tax = helpers.calc_tax_amount(taxable_subtotal, state.delivery_tax.tax)
                }else{
                    delivery_tax = parseFloat(state.delivery_tax.tax);
                }
            }

            commit('SET_RENTERS', state.renters);
            commit('SET_CART_DISCOUNT_AMOUNT', discount_amount);
            commit('SET_CART_NON_TAX_TOTAL', non_tax_total);
            commit('SET_CART_SUBTOTAL', subtotal);
            commit('SET_CART_DISCOUNTED_SUBTOTAL', discounted_sub_total);
            commit('SET_CART_DISCOUNTED_PACKAGE_TOTAL', (package_total - discount_amount));
            commit('SET_CART_TAX_TOTAL', tax_total);
            commit('SET_CART_DELIVERY_TAX', delivery_tax);
            commit('SET_CART_TOTAL', (discounted_sub_total+tax_total+delivery_tax));

        },

        updateGTMLayer({state}, {event, item, item_type}){
            console.log(event);
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    'event': event,
                    'item_name':  item.name+' - '+item_type,
                    'item_id': item.id,
                    'quantity': item.qty ? item.qty : 1,
                });
                console.log(dataLayer);
            }
        },
        klaviyoIdentify(){
            let user = helpers.getUser();
            if (typeof klaviyo !== 'undefined' && user) {
                klaviyo.identify({
                    '$email': user.email,
                    '$first_name': user.first_name,
                    '$last_name': user.last_name,
                });
            }
        },
        klaviyoAddedToCart({state, dispatch}, {item, item_type}) {
            if (typeof klaviyo !== 'undefined') {
                dispatch('klaviyoIdentify')
                klaviyo.track("Added to Cart", {
                    'AddedItemProductName': item.name + ' - ' + item_type,
                    'AddedItemProductID': item.id,
                    'AddedItemQuantity': item.qty ? item.qty : 1,
                    'season': 'winter',
                });
            }
        },
        klaviyoStartedCheckout({state, dispatch}) {
            if (typeof klaviyo !== 'undefined') {
                dispatch('klaviyoIdentify')
                // Generate unique event ID
                const eventId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);

                // Get cart items for tracking
                const itemNames = [];
                const items = [];

                // Add renters' packages, add-ons, and clothing to tracking
                if (state.renters && state.renters.length > 0) {
                    state.renters.forEach(renter => {
                        // Add package for each renter
                        if (renter.package_name) {
                            itemNames.push(renter.package_name);
                            items.push({
                                ProductID: renter.package_id,
                                ProductName: renter.package_name,
                                Quantity: 1,
                            });
                        }

                        // Add add-ons for each renter
                        if (renter.add_ons && renter.add_ons.length > 0) {
                            renter.add_ons.forEach(addon => {
                                itemNames.push(addon.name);
                                items.push({
                                    ProductID: addon.id,
                                    ProductName: addon.name,
                                    Quantity: addon.qty || 1,
                                });
                            });
                        }

                        // Add clothing for each renter
                        if (renter.clothing_name) {
                            itemNames.push(renter.clothing_name);
                            items.push({
                                ProductID: renter.clothing_resort_id,
                                ProductName: renter.clothing_name,
                                Quantity: 1,
                            });
                        }
                    });
                }

                // Add invoice addons to tracking
                if (state.cart.invoice_addons && state.cart.invoice_addons.length > 0) {
                    state.cart.invoice_addons.forEach(addon => {
                        itemNames.push(addon.name);
                        items.push({
                            ProductID: addon.id,
                            ProductName: addon.name,
                            Quantity: addon.qty || 1,
                        });
                    });
                }

                klaviyo.track("Started Checkout", {
                    "$event_id": eventId,
                    "ItemNames": itemNames,
                    "Items": items,
                    'season': 'winter',
                });
                console.log('Klaviyo Started Checkout tracked:', {eventId, itemNames, items});
            }
        },
        checkoutGTMLayer({state}){
            console.log('begin_checkout');
            if (typeof dataLayer !== 'undefined') {
                dataLayer.push({
                    'event': 'begin_checkout'
                });
                console.log(dataLayer);
            }
        },

        updateCartWithRenters({commit, state, getters, dispatch}, pkg){
            pkg.qty = pkg.qty ? parseInt(pkg.qty) : 0;//avoid empty string
            let newPkg = {
                'id': pkg.id,
                'image': pkg.image,
                'package_resort_id': pkg.package_resort_id,
                'name': pkg.name,
                'price': pkg.price,
                'max_price': pkg.max_price,
                'total': getters.getDiscountedPackageTotal(pkg),
                'qty': pkg.qty,
                'equip_type': pkg.equip_type,
                'ski_only': pkg.ski_only,
                'is_for_kid': (pkg.has_limitations === 1 || pkg.is_krf === 1 || pkg.is_tots === 1),
                'is_teen': pkg.is_teen === 1,
                'is_tots': pkg.is_tots === 1,
            }
            let cartPkg = state.cart.packages.find(item => item.id === pkg.id)
            if(cartPkg){
                cartPkg.qty = pkg.qty;
                cartPkg.total = getters.getDiscountedPackageTotal(pkg);
                dispatch('updateGTMLayer', {'event': 'add_to_cart', 'item': cartPkg, 'item_type': 'Package'})
                dispatch('klaviyoAddedToCart', {'item': cartPkg, 'item_type': 'Package'})

                //remove package from cart if qty set to 0 or less
                if(cartPkg.qty <= 0){
                    state.cart.packages = state.cart.packages
                        .filter(function(element) {
                            return element.id !== cartPkg.id;
                        });
                    dispatch('updateGTMLayer', {'event': 'remove_from_cart', 'item': cartPkg, 'item_type': 'Package'})
                }

            }else{
                if (newPkg.qty > 0)
                    state.cart.packages.push(newPkg)
                dispatch('updateGTMLayer', {'event': 'add_to_cart', 'item': newPkg, 'item_type': 'Package'})
                dispatch('klaviyoAddedToCart', {'item': newPkg, 'item_type': 'Package'})
            }
            commit('SET_RENTERS', []);
            let renters = []
            if(state.cart && state.cart.packages && state.cart.packages.length > 0){
                state.cart.packages.forEach(function(pkgItem){
                    //fill selected renters
                    // let selected_renter_ids = [];
                    // state.selected_skis.forEach(function(skiPkgs){
                    //     skiPkgs.forEach(function(skiPkg){
                    //         if(skiPkg && skiPkg.renter_id && skiPkg.package.id === pkgItem.package_resort_id){
                    //             selected_renter_ids.push(skiPkg.renter_id)
                    //         }
                    //     })
                    // });
                    // state.selected_snowboards.forEach(function(snowPkgs){
                    //     snowPkgs.forEach(function(snowPkg){
                    //         if(snowPkg && snowPkg.renter_id && snowPkg.package.id === pkgItem.package_resort_id){
                    //             selected_renter_ids.push(snowPkg.renter_id)
                    //         }
                    //     })
                    // });
                    // let selected_renters = state.repeat_renters.filter(item => selected_renter_ids.includes(item.id))
                    // selected_renters.forEach(function(selectedRenter){
                    //     let renter = {
                    //         'renter_id' : selectedRenter.id,
                    //         'first_name': selectedRenter.first_name,
                    //         'last_name' :  selectedRenter.last_name,
                    //         'resort_id' : state.form.resort_id,
                    //         'package_name': pkgItem.name,
                    //         'package_price': pkgItem.price,
                    //         'package_id' : pkgItem.id,
                    //         'number_of_days': getters.getRentalLength,
                    //         'package_resort_id': pkgItem.package_resort_id,
                    //         'clothing_resort_id' : null,
                    //         'add_ons': [],
                    //         'free_package_resort_id': null,
                    //         'email':  selectedRenter.email,
                    //         'phone': selectedRenter.phone,
                    //         'type': selectedRenter.type,
                    //         'gender':  selectedRenter.gender,
                    //         'age':  selectedRenter.age,
                    //         'dob':  selectedRenter.dob,
                    //         'ft' : selectedRenter.ft,
                    //         'in' : selectedRenter.in,
                    //         'lb' : selectedRenter.lb,
                    //         'cm' : selectedRenter.cm,
                    //         'kg' : selectedRenter.kg,
                    //         'height_in_us': selectedRenter.height_in_us,
                    //         'shoe_size_in_us': selectedRenter.shoe_size_in_us,
                    //         'shoe_country' :  'US',
                    //         'unit_system': 'ft/in/lbs',
                    //         'weight': selectedRenter.weight,
                    //         'weight_in_us': selectedRenter.weight_in_us,
                    //         'shoe_size' :  selectedRenter.shoe_size,
                    //         'shoe_type' : selectedRenter.shoe_type,
                    //         'ability' :  selectedRenter.ability,
                    //         'bring_boot' : false,
                    //         'clothing_price' : '',
                    //         'addons_price' : 0,
                    //         'service_total' : 0,
                    //         'dw_total' : 0,
                    //         'non_tax_total' : 0,
                    //         'price' : 0,
                    //         'discount' : 0,
                    //         'total_price' : 0,
                    //         'is_dob_updated' : true,
                    //         'is_type_updated' : true,
                    //     };
                    //     dispatch('changeShoeOptions', {'renter': renter, 'is_default': false})
                    //     renters.push(renter)
                    // });
                    //fill remain qty
                    for(let i = 0; i < pkgItem.qty; i++){
                        let renter = {
                            'old_id': null,
                            'renter_id' : '',
                            'first_name': '',
                            'last_name' : '',
                            'resort_id' : state.form.resort_id,
                            'package_name': pkgItem.name,
                            'package_price': pkgItem.price,
                            'package_max_price': pkgItem.max_price,
                            'package_id' : pkgItem.id,
                            'number_of_days': getters.getRentalLength,
                            'package_resort_id': pkgItem.package_resort_id,
                            'clothing_resort_id' : null,
                            'add_ons': [],
                            'free_package_resort_id': null,
                            'kid_free': false,
                            'email': '',
                            'phone': '',
                            'type': pkgItem.equip_type,
                            'snowboard_stance': null,
                            'gender': '',
                            'age': '',
                            'dob': '',
                            'ft' : '',
                            'in' : '',
                            'lb' : '',
                            'cm' : '',
                            'kg' : '',
                            'height_in_us': '',
                            'shoe_country' :  'US',
                            'unit_system': 'ft/in/lbs',
                            'weight': '',
                            'shoe_size' : '',
                            'shoe_type' : '',
                            'ability' : '',
                            'clothing_price' : '',
                            'addons_price' : 0,
                            'service_total' : 0,
                            'dw_total' : 0,
                            'non_tax_total' : 0,
                            'price' : 0,
                            'discount' : 0,
                            'total_price' : 0,
                            'is_dob_updated' : true,
                            'is_type_updated' : true,
                            // 'bring_boot': pkgItem.ski_only,
                            'bring_boot': null,//by default no option should be selected
                            'is_kid': pkgItem.is_for_kid, //true if kid package selected else false if adult pkg is seleced
                            'is_teen': pkgItem.is_teen, //true if teen package selected else false if adult or kid pkg is seleced
                        };
                        renters.push(renter)
                    }
                });
            }
            commit('SET_RENTERS', renters);
        },

        changeShoeOptions({state}, {renter, is_default}){
            let options = [];
            let selected = false;

            // if (renter.shoe_country == 'US' || renter.shoe_country == undefined) {

            if (renter.shoe_country == 'US' || renter.shoe_country == undefined) {

                if (renter.shoe_type == 'Men' || renter.shoe_type == 'M') {
                    options = state.US_M_options;
                } else if (renter.shoe_type == 'Women' || renter.shoe_type == 'W') {
                    options = state.US_W_options;
                } else if (renter.shoe_type == 'Youth' || renter.shoe_type == 'Y') {
                    options = state.US_kids_options;
                } else {
                    options = state.US_M_options;
                }


            } else if (renter.shoe_country == 'UK') {

                if (renter.shoe_type == 'Men' || renter.shoe_type == 'M') {
                    options = state.UK_M_options;
                } else if (renter.shoe_type == 'Women' || renter.shoe_type == 'W') {
                    options = state.UK_W_options;
                } else if (renter.shoe_type == 'Youth' || renter.shoe_type == 'Y') {
                    options = state.UK_kids_options;
                } else {
                    options = state.UK_M_options;
                }

            } else if (renter.shoe_country == 'EU') {
                if (renter.shoe_type == 'Men' || renter.shoe_type == 'M') {
                    options = state.EU_M_options;
                } else if (renter.shoe_type == 'Women' || renter.shoe_type == 'W') {
                    options = state.EU_W_options;
                } else if (renter.shoe_type == 'Youth' || renter.shoe_type == 'Y') {
                    options = state.EU_kids_options;
                } else {
                    options = state.EU_M_options;
                }
            } else if (renter.shoe_country == 'MONDO') {
                options = MO_options;
            }


            // Removing all option to the select box
            renter.shoe_sizes = [];

            // Setting options available for the select box
            renter.shoe_sizes = options;
            // Getting the middle value of the array

            let middle_value = Math.round((options.length - 1) / 2);
            $.each(options, function (index, value) {
                if (value == null) {
                    selected = true;
                }
            });
            if (!selected) {
                renter.shoe_sizes.splice(middle_value, 0, null);
            }
        },

        logout({state, dispatch}) {
            DataService.logout()
                .then(res => {
                    localStorage.removeItem('getUser');
                    localStorage.removeItem('getToken');
                    dispatch('resetStorageAndStore');
                    state.auth_user = helpers.getUser();
                    // router.push({name: 'Login'})
                    if(router.currentRoute.name !== 'Step1'){
                        NProgress.start();
                        router.push({'name': 'Step1'})
                    }
                })
                .catch(err => {
                    helpers.clearLocalStorage();
                    localStorage.removeItem('getUser');
                    localStorage.removeItem('getToken');
                    dispatch('resetStorageAndStore');
                    state.auth_user = helpers.getUser();
                    if(router.currentRoute.name !== 'Step1'){
                        NProgress.start();
                        router.push({'name': 'Step1'})
                    }
                    console.log(err);
                })
        },
        resetStorageAndStore({state, dispatch}){
            helpers.clearLocalStorage();
            //reset state
            Object.assign(state, getDefaultState());
            state.base_url = base_url;
            state.storage_loaded = true;
            dispatch('setStep1Params', window.location.search)
            dispatch('fetchAllResorts');
        },
        setAuthUser({state}){
            state.auth_user = helpers.getUser();
        }
    },
    getters: {
        getRentalLength: state => {
            return moment(state.form.return_date).diff(moment(state.form.first_day_skiing), 'days') + 1 || 0;
        },


        getInvoiceAddons: (state) => () => {
            return state.cart && Array.isArray(state.cart.invoice_addons) ? state.cart.invoice_addons : [];
        },

        getBootUpgradeInvoiceAddons: (state, getters) => {
            let invoice_addons = getters.getInvoiceAddons();
            return invoice_addons.filter(function (item) {
                return item.boot_upgrade === 1;
            });
        },

        getBootHeatedInvoiceAddons: (state, getters) => {
            let invoice_addons = getters.getInvoiceAddons();
            return invoice_addons.filter(function (item) {
                return  item.heated_boot === 1;
            });
        },

        getBootUpgradeInvoiceAddonsLength: (state, getters) => {
            let boot_upgrade_count = getters.getBootUpgradeInvoiceAddons.length;
            return boot_upgrade_count > 0 ? boot_upgrade_count : 0;
        },

        getBootHeatedInvoiceAddonsLength: (state, getters) => {
            let boot_heated_count = getters.getBootHeatedInvoiceAddons.length;
            return boot_heated_count > 0 ? boot_heated_count : 0;
        },

        getRenterClothing: (state) => (clothing_resort_id, age) => {
            let clothing_resort = null
            if (age <= 12) {
                clothing_resort = state.jrClothing.find(item => item.id === clothing_resort_id);
            } else {
                clothing_resort = state.adultClothing.find(item => item.id === clothing_resort_id);
            }

            return {
                name: clothing_resort ? clothing_resort.clothing.name : '',
                price: clothing_resort ? clothing_resort.price : 0
            }
        },

        getDiscountedPackageTotal: (state, getters) => (pkg) => {
            let discount = 0;
            if (state.coupon && isPackageEligibleForDiscount(pkg, state.coupon)) {
                 discount = state.coupon ? parseFloat(state.coupon.discount) : 0;
            }
            let total = 0;
            total = parseFloat(helpers.getDiscountedPrice(parseFloat(pkg.price), discount))
                * parseFloat(pkg.qty) * parseFloat(getters.getRentalLength);

            return total;
        },

        getDiscountedRenterTotal: (state, getters) => (renter) => {
            let discount = 0;
            if (state.coupon && isPackageEligibleForDiscount(renter, state.coupon)) {
                discount = state.coupon ? parseFloat(state.coupon.discount) : 0;
            }
            let addon_discount = state.coupon && state.coupon.addon_discount ? parseFloat(state.coupon.addon_discount) : 0;
            let number_of_days = parseInt(renter.number_of_days);
            let package_price = parseFloat(renter.package_price);
            let addons_total = 0;
            let package_total = 0;
            if(renter.add_ons && renter.add_ons.length > 0){
                renter.add_ons.forEach(function (addon) {
                    let unit_price = parseFloat(getters.getAddonDailyPrice(addon));
                    let qty = parseInt(addon.qty);
                    if (addon_discount && isAddonEligibleForDiscount(addon, state.coupon)) {
                        unit_price = parseFloat(helpers.getDiscountedPrice(unit_price, addon_discount));
                    }
                    if(addon.pricing === 'one_time'){
                        addons_total += unit_price * qty;
                    }else{
                        addons_total += unit_price * qty * number_of_days;
                    }
                })
            }

            let clothing_unit_price = parseFloat(renter.clothing_price);
            if (addon_discount && renter.clothing_resort_id) {
                clothing_unit_price = parseFloat(helpers.getDiscountedPrice(clothing_unit_price, addon_discount));
            }
            let clothing_total = clothing_unit_price * number_of_days;

            package_total = parseFloat(helpers.getDiscountedPrice(package_price, discount)) * number_of_days;

            let total = addons_total + package_total + clothing_total;
            return parseFloat(total);
        },

        getRenterTotal: (state, getters) => (renter) => {
            let number_of_days = parseInt(renter.number_of_days);
            // let package_price = state.coupon ? parseFloat(helpers.getDiscountedPrice(renter.package_price, state.coupon.discount)) : parseFloat(renter.package_price);
            let package_price = parseFloat(renter.package_price);
            let addons_total = 0;
            if(renter.add_ons && renter.add_ons.length > 0){
                renter.add_ons.forEach(function (addon) {
                    if(addon.pricing === 'one_time'){
                        addons_total += parseFloat(getters.getAddonDailyPrice(addon)) * parseInt(addon.qty);
                    }else{
                        addons_total += parseFloat(getters.getAddonDailyPrice(addon)) * parseInt(addon.qty) * number_of_days;
                    }
                })
            }

            let clothing_price = parseFloat(renter.clothing_price);

            let total = addons_total + (package_price * number_of_days) + (clothing_price * number_of_days)
            return parseFloat(total);
        },

        getAddonDailyPrice: (state, getters)  => (addOn) => {
            // let number_of_days = getters.getRentalLength
            // let price = 0;
            // if (addOn.pricing === 'day') {
            //     // Getting Daily price
            //     price = addOn.price;
            // } else if (addOn.pricing === 'week') {
            //     // Getting Daily price from weekly
            //     price = addOn.price / 7;
            // } else if (addOn.pricing === 'month') {
            //     // Getting Daily price from weekly
            //     price = addOn.price / 30;
            // } else {
            //     // Considering price as daily price if any pricing not set
            //     price = addOn.price;
            // }
            //
            // //if price after multiply with number of days exceeded than needs to set max_price
            // if (addOn.max_price && ((price * number_of_days) > addOn.max_price)) {
            //     price = number_of_days !== 0 ? addOn.max_price / number_of_days : 0.00;
            // }

            return parseFloat(addOn.price);
        },

        invoiceOneTimeAddons: (state, getters) => {
            let invoice_addons = getters.getInvoiceAddons();
            return invoice_addons.filter(function (item) {
                return item.pricing === 'one_time';
            });
        },

        invoiceNonPercentAddons: (state, getters) => {
            let invoice_addons = getters.getInvoiceAddons();
            return invoice_addons.filter(function (item) {
                return item.pricing !== 'percent' && item.pricing !== 'one_time';
            });
        },

        invoicePercentAddons: (state, getters) => {
            let invoice_addons = getters.getInvoiceAddons();
            return invoice_addons.filter(function (item) {
                return  item.pricing === 'percent';
            });
        },

        getAddonsDailyPriceTotal: (state, getters) => (addons) => {
            let addons_price = 0.00;
            if(addons && addons.length > 0){
                addons.forEach(function(addon){
                    addons_price += getters.getAddonDailyPrice(addon) * parseInt(addon.qty);
                });
            }

            return parseFloat(addons_price);
        },

        getPercentAddonsTotal: (state, getters) => (addons, discounted_sub_total) => {
            let addons_price = 0.00;
            if(addons && addons.length > 0){
                addons.forEach(function(addon){
                    addons_price += getters.getPercentPrice(addon, discounted_sub_total) * parseInt(addon.qty);
                });
            }

            return parseFloat(addons_price);
        },

        getPercentPrice: (state, getters) => (addon, discounted_sub_total) => {
            let addon_price = helpers.getDiscountRate(discounted_sub_total, addon.price);
            //if price after multiply with number of days exceeded than needs to set max_price
            if (addon.max_price && (addon_price > addon.max_price)) {
                addon_price = addon.max_price;
            }
            return parseFloat(addon_price);
        },
        getLimitationAge: (state) => {
            return state.package_limitations ? parseInt(state.package_limitations.age) : 12;
        },
        getTeenLimitationAge: (state) => {
            return state.package_limitations && state.package_limitations.teen_age ? parseInt(state.package_limitations.teen_age) : 17;
        },
        getTotsLimitationAge: (state) => {
            return state.package_limitations && state.package_limitations.tots_age ? parseInt(state.package_limitations.tots_age) : 5;
        },
        getHasTotsPackages: (state) => {
            if (state.has_tots_packages) {
                return true;
            }
            return state.packages.some(pkg => pkg.is_tots === 1 || pkg.is_tots === true || pkg.is_tots === '1');
        },

        getResortPhone: (state) => {
            let resort = state.all_resorts.find(resort => resort.id === state.form.resort_id);
            return resort && helpers.usa_phone_format(resort.phone);
        },

        getResortName: (state) => {
            let resort = state.all_resorts.find(resort => resort.id === state.form.resort_id);
            return resort && resort.name;
        },
        getResortCode: (state) => {
            let resort = state.all_resorts.find(resort => resort.id === state.form.resort_id);
            return resort && resort.code;
        },
        getResortCountry: (state) => {
            let resort = state.all_resorts.find(resort => resort.id === state.form.resort_id);
            return resort && resort.country ? resort.country : 'united states';
        },
        getIsBillingOpen: (state) => {
            let resort = state.all_resorts.find(resort => resort.id === state.form.resort_id);
            if(resort){
                return resort.billing_opened === 1;
            }else {
                return true;
            }
        },
        getAddonRenters: (state) => (pkg_resort_ids) => {
            return state.renters.filter(item => pkg_resort_ids.includes(item.package_resort_id));
        },

        getDeliveryFee: (state) => {
            return  state.form.is_pickup ? 0.00 : parseFloat(state.delivery_fee);
        },

        getStep1Route: (state) => {
            // Convert the query parameters string into an object
            const queryParamsString = state.form.step1_params;
            const queryParamsObject = {};

            if(queryParamsString){
                queryParamsString
                    .slice(1) // Remove the leading "?"
                    .split('&')
                    .forEach((param) => {
                        const [key, value] = param.split('=');
                        queryParamsObject[key] = value;
                    });

                if ('portal_name' in queryParamsObject || state.form.portal_url_code) {
                    // If 'portal_name' is present in queryParamsObject or state.form.portal_url_code is truthy
                    const portal_name = queryParamsObject.portal_name || state.form.portal_url_code;
                    // Extract 'portal_name' and exclude it from queryParamsObject
                    delete queryParamsObject.portal_name;

                    return { name: 'Step1Portal', params: { url_code: portal_name }, query: queryParamsObject };
                } else {
                    // Otherwise, use the regular Step1 route
                    return { name: 'Step1', query: queryParamsObject };
                }
            }else{
                return { name: 'Step1', query: queryParamsObject };
            }

        }
    }
});
